module.exports = function(it){
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


// WEBPACK FOOTER //
// ./packages/emdb/node_modules/core-js/library/modules/_is-object.js